'use strict';

angular.module('ClinicApp').controller('IBHealthResyncModal', function($scope, $modalInstance, calendlyLink) {
  $scope.calendlyLink = calendlyLink;

  OpencareAnalytics.trackPageView({
    pageType: OpencareAnalytics.pageTypes.PROVIDER_AVAILABILITY,
    pageName: 'IB Resync',
    name: 'ib-resync-troubleshoot',
    practiceId: _.get($scope, '$parent.clinic.id'),
    content: {
      link: 'book-call',
    },
  });

  $scope.close = function() {
    OpencareAnalytics.trackClick({
      pageType: OpencareAnalytics.pageTypes.PROVIDER_AVAILABILITY,
      pageName: 'IB Resync',
      name: 'ib-resync-troubleshoot',
      practiceId: _.get($scope, '$parent.clinic.id'),
      content: {
        value: 'close',
      },
    });

    $modalInstance.close();
  };

  $scope.trackCta = function() {
    OpencareAnalytics.trackClick({
      pageType: OpencareAnalytics.pageTypes.PROVIDER_AVAILABILITY,
      pageName: 'IB Resync',
      name: 'ib-resync-troubleshoot',
      practiceId: _.get($scope, '$parent.clinic.id'),
      content: {
        value: 'book-call',
      },
    });
  };
});
